<template>
  <div>Edit Emergency Type</div>
  <select v-if="!isSaving" class="form-select mt-1 mb-2" v-model="selectedEmergencyType">
    <option :value="etype.typeid" v-for="etype in emergencyTypes" :key="etype.typeid">
      {{ etype.name }}
    </option>
  </select>
  <SpinnerBlock v-if="isSaving" />

  <button @click="confirm" class="btn btn-danger w-100 mt-1" type="button">Confrm</button>
</template>

<script setup>
import emergencyService from "@/services/emergencyService";
import toastService from "@/services/toastService";
import { ref, watch } from "vue";
import SpinnerBlock from "../animations/SpinnerBlock.vue";
const emergencyTypes = [
  { typeid: 0, name: "Unknown Emergency" },
  { typeid: 1, name: "Vehicular Accident" },
  { typeid: 2, name: "Domestic Violence" },
  { typeid: 3, name: "Fire Incident" },
  { typeid: 4, name: "Drowning Incident" },
  { typeid: 5, name: "Medical Assistance" },
  { typeid: 100, name: "Others" },
];
//eslint-disable-next-line
const emit = defineEmits(["confirmed", "closed"]);
//eslint-disable-next-line
const props = defineProps({
  emergncyTpe: { type: Number },
  id: { type: String },
});

const isSaving = ref(false);

const selectedEmergencyType = ref(0);
watch(
  () => props.emergncyTpe,
  (newId) => {
    if (newId) selectedEmergencyType.value = newId;
  },
  { immediate: true }
);
watch(
  () => props.id,
  (newId) => {
    if (newId) selectedEmergencyType.value = props.emergncyTpe;
  },
  { immediate: true }
);

const confirm = async () => {
  isSaving.value = true;
  const resp = await emergencyService.changeEmergencyType(
    props.id,
    selectedEmergencyType.value
  );
  if (resp.success) {
    emit("confirmed", selectedEmergencyType.value);
  } else {
    toastService.error(resp.message);
  }
  isSaving.value = false;
};
</script>
